import { EditingCategory, ProductKind, ProductKindsWithDocumentGallery } from 'constants/product'

import { ProductDTO } from 'models/product'

const noImageFloorPlanKinds = new Set([
  ProductKind.MATTERPORT_FLOOR_PLAN_WITHOUT_VISIT,
  ProductKind.MOBILE_APPLICATION_FLOOR_PLAN,
])

export type ImageUploadProductShape = Pick<ProductDTO, 'kind' | 'category' | 'isVideo' | 'isVirtualVisit' | 'isFloorPlan'>

/**
 * Whether the creative delivers this product through the upload page (`/:id/upload`) instead of the gallery.
 *
 * Mirrored in Lua as `AssignmentSync.isImageUpload` (`bkbn-com/lightroom-upload-plugin`,
 * `src/Backbone.lrdevplugin/AssignmentSync.lua`, introduced in that repo's #2), which decides where "Show in Backbone"
 * deep-links. Nothing detects drift between the two: adding a `ProductKind` here means editing `AssignmentSync.lua` and
 * `tests/test_assignment_sync.lua` in the same change, or the plugin sends creatives to the page this rule bounces them
 * off. A shared (kind, expected) fixture consumed by both suites is the real fix.
 */
export function isImageUploadProduct(product: ImageUploadProductShape): boolean {
  if (product.isVideo) return false
  if ((product.isVirtualVisit && product.kind === ProductKind.HD) || product.kind === ProductKind.SD) return false
  if (product.kind === ProductKind.FLOORFY_VIRTUAL_TOUR) return false
  if (ProductKindsWithDocumentGallery.has(product.kind)) return false
  if (product.kind === ProductKind.MATTERPORT_FLOOR_PLAN_WITH_VISIT) return false
  // A floor plan whose kind the API omitted cannot be matched against noImageFloorPlanKinds, so it stays on the gallery rather than defaulting into the upload page
  if (product.isFloorPlan) return !!product.kind && product.category !== EditingCategory.EDITING && !noImageFloorPlanKinds.has(product.kind)
  return true
}
